import useReveal from '../../hooks/useReveal.js';

/**
 * Reveal — declarative wrapper around useReveal for the standard
 * fade-up-on-scroll entrance (.reveal / .is-in in globals.css).
 *
 * Being a component (not a hook) it can be used inside .map() loops,
 * which useReveal cannot.
 *
 * Props:
 *   as: string — rendered element/tag (default 'div')
 *   delay: number — ms added before the transition runs once in view;
 *     use small steps (60–150ms) to stagger siblings that enter together
 *   className: string — merged onto the element alongside `reveal`
 */
export default function Reveal({
  as: Tag = 'div',
  delay = 0,
  className = '',
  style,
  children,
  ...rest
}) {
  const ref = useReveal();
  const mergedStyle = delay
    ? { '--reveal-delay': `${delay}ms`, ...style }
    : style;

  return (
    <Tag
      ref={ref}
      className={className ? `reveal ${className}` : 'reveal'}
      style={mergedStyle}
      {...rest}
    >
      {children}
    </Tag>
  );
}
